import { Check, X } from 'lucide-react'
import Section, { Reveal, SectionHeading } from './Section'

const WITHOUT = [
  'Hours in CAM software for every new part',
  'Tool order, feeds and speeds worked out manually',
  'Expensive seats and a steep learning curve',
  'Every drawing revision means starting over',
]
const WITH = [
  'AI reads the drawing and finds the features',
  'Tools, feeds and speeds chosen for you',
  'Changes in plain language, not menus',
  'A program verified against the drawing',
]

/** Programming the usual way versus with GCodr's AI, side by side. */
export default function Comparison() {
  return (
    <Section id="why" labelledBy="why-title" className="px-5 py-20 md:px-12 md:py-28">
      <SectionHeading id="why-title" label="Why GCodr" lead="Let AI do the programming." rest="You make the parts." />
      <div className="mt-14 grid gap-4 md:grid-cols-2">
        <Reveal className="rounded-xl border border-white/[0.07] bg-white/[0.015] p-6 md:p-8">
          <p className="font-mono text-[11px] uppercase tracking-widest text-slate-500">The usual way</p>
          <ul className="mt-6 space-y-4">
            {WITHOUT.map(t => (
              <li key={t} className="flex gap-3 font-display text-[15px] text-slate-500">
                <X className="mt-0.5 h-4 w-4 shrink-0 text-slate-600" />{t}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.08} className="rounded-xl border border-cyan-500/30 bg-cyan-500/[0.04] p-6 shadow-[0_0_60px_-20px_rgba(6,182,212,0.35)] md:p-8">
          <p className="font-mono text-[11px] uppercase tracking-widest text-cyan-400">With GCodr's AI</p>
          <ul className="mt-6 space-y-4">
            {WITH.map(t => (
              <li key={t} className="flex gap-3 font-display text-[15px] text-slate-200">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-cyan-400" />{t}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </Section>
  )
}
